import { Module } from "vuex";
import { INewsState } from "@/core/interfaces/news.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const newsModule: Module<INewsState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default newsModule;
